"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var padNumber_1 = require("./methods/padNumber");
/**
 * klasa reprezentująca różnicę czasu
 */
var TimeSpan = /** @class */ (function () {
    function TimeSpan(ms, lateDate, earlyDate) {
        this.ms = ms;
        this.lateDate = lateDate;
        this.earlyDate = earlyDate;
    }
    TimeSpan.diff = function (lateDate, earlyDate) {
        var dt1 = new Date(lateDate);
        var dt2 = new Date(earlyDate);
        return new TimeSpan(dt1.getTime() - dt2.getTime(), dt1, dt2);
    };
    Object.defineProperty(TimeSpan.prototype, "totalMiliseconds", {
        /**
         * całkowita liczba milisekund
         */
        get: function () {
            return this.ms;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimeSpan.prototype, "miliseconds", {
        /**
         * ilośc milisekund po odjęciu sekund, minut, godzin i dni
         */
        get: function () {
            return this.ms % 1000;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimeSpan.prototype, "totalSeconds", {
        /**
         * całkowita liczba sekund = liczba milisekund /1000
         */
        get: function () {
            return this.ms / 1000;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimeSpan.prototype, "seconds", {
        /**
         * liczba sekund po odjęciu minut, godzin i dni
         */
        get: function () {
            // return this.ms % (1000 * 60);
            return Math.trunc((this.totalMinutes % 1) * 60);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimeSpan.prototype, "totalMinutes", {
        /**
         * całkowita liczba minut
         */
        get: function () {
            return this.ms / 60000 /* 1000 * 60 */;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimeSpan.prototype, "minutes", {
        /**
         * liczba minut po odjęciu godzin i dni
         */
        get: function () {
            return Math.trunc((this.totalHours % 1) * 60);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimeSpan.prototype, "totalHours", {
        /**
         * całkowita liczba godzin
         */
        get: function () {
            return this.ms / 3600000 /* 1000 * 60 * 60 */;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimeSpan.prototype, "hours", {
        /**
         * liczba godzn po odjęciu liczby dni
         */
        get: function () {
            return Math.trunc((this.totalDays % 1) * 24);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimeSpan.prototype, "totalDays", {
        /**
         * całkowita liczba dni
         */
        get: function () {
            return this.ms / 86400000 /*1000 * 60 * 60 * 24*/;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimeSpan.prototype, "days", {
        /**
         * liczba dni, wartośc całkowita
         */
        get: function () {
            return Math.trunc(this.totalDays);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimeSpan.prototype, "months", {
        /**
         * liczba miesięcy, wartośc całkowita
         */
        get: function () {
            if (this.earlyDate && this.lateDate) {
                var res = (this.lateDate.getFullYear() - this.earlyDate.getFullYear()) * 12;
                res += this.lateDate.getMonth();
                res -= this.earlyDate.getMonth();
                if (res > 0) {
                    if (this.lateDate.getDate() < this.earlyDate.getDate()) {
                        res--;
                    }
                }
                else if (res < 0) {
                    if (this.lateDate.getDate() > this.earlyDate.getDate()) {
                        res++;
                    }
                }
                return res;
            }
            else {
                return Math.trunc(this.days / 30);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * róznica w postaci HH:mm:ss
     */
    TimeSpan.prototype.toString = function () {
        return padNumber_1.default(Math.trunc(this.totalHours), 2)
            + ':'
            + padNumber_1.default(this.minutes, 2)
            + ':'
            + padNumber_1.default(this.seconds, 2);
    };
    return TimeSpan;
}());
exports.default = TimeSpan;
//# sourceMappingURL=TimeSpan.js.map